import { useState } from 'react';
import { toast } from 'sonner';
import api from '@/shared/api/client';
import { Button } from '@/shared/ui/button';
import { OPTIONS_AGREGATEUR_MANDAT, lienComplet } from '@/shared/utils/agregateurMandat';

/**
 * LE LIEN D'INSCRIPTION QR D'UN AGRÉGATEUR, GÉNÉRÉ PAR L'OPÉRATEUR (C8a, relecture 15/10).
 *
 * Le formulaire QR est public : c'est le client qui le remplit, et il ne doit pas pouvoir
 * choisir lui-même l'agrégateur de son mandat (le choix fixe pour toujours à qui ses
 * équipements seront déclarés). L'agrégateur ne vient donc que de ce lien, signé par le
 * serveur ; un lien retouché est refusé à la soumission. Le lien nu `/onboarding` reste
 * celui d'un mandat générique.
 */
export default function LienInscriptionAgregateur() {
  const [agregateur, setAgregateur] = useState('symphonics');
  const [lien, setLien] = useState('');

  const generer = async () => {
    try {
      const { data } = await api.post('/admin/onboarding/lien-agregateur', { agregateur });
      setLien(lienComplet(window.location.origin, data.lien));
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Le lien n\'a pas pu être généré');
    }
  };

  const copier = async () => {
    try { await navigator.clipboard.writeText(lien); toast.success('Lien copié'); } catch {
      toast.error('Copie impossible : sélectionnez le lien à la main');
    }
  };

  return (
    <div className="rounded-lg border border-neutral-200 bg-white p-3 flex flex-wrap items-end gap-3"
         data-testid="lien-inscription-agregateur">
      <div className="space-y-1">
        <label htmlFor="lien-agregateur" className="text-[11px] font-medium text-neutral-700">
          Lien d&apos;inscription QR pour
        </label>
        <select id="lien-agregateur" value={agregateur} data-testid="lien-agregateur-choix"
                onChange={(e) => { setAgregateur(e.target.value); setLien(''); }}
                className="h-8 rounded-md border border-neutral-200 px-2 text-[12px] bg-white">
          {OPTIONS_AGREGATEUR_MANDAT.filter((o) => o.valeur).map((o) => (
            <option key={o.valeur} value={o.valeur}>{o.libelle}</option>
          ))}
        </select>
      </div>
      <Button size="sm" variant="outline" onClick={generer} data-testid="lien-agregateur-generer">
        Générer le lien
      </Button>
      {lien && (
        <div className="flex items-center gap-2 min-w-0 flex-1">
          <code className="text-[11px] truncate" title={lien} data-testid="lien-agregateur-valeur">{lien}</code>
          <Button size="sm" variant="ghost" onClick={copier}>Copier</Button>
        </div>
      )}
    </div>
  );
}
